export default "__VITE_ASSET__bWhfVlki__"